import { useState } from 'react';
import { getSecurityTier, isVaultUnlocked } from '@/services/vaultService';
import { IconVault } from '@/components/Icons';
import VaultUnlockDialog from '@/components/VaultUnlockDialog';

export default function VaultIndicator() {
  const [showUnlock, setShowUnlock] = useState(false);
  const tier = getSecurityTier();
  const unlocked = isVaultUnlocked();

  // Only show for vault users
  if (tier === 'cloud') return null;

  return (
    <>
      <button
        onClick={() => !unlocked && setShowUnlock(true)}
        className={`flex items-center gap-1.5 px-2 py-1 rounded-lg text-[11px] font-medium border text-amber-400 border-amber-500/30 bg-amber-500/5 ${!unlocked ? 'cursor-pointer hover:bg-amber-500/10' : 'cursor-default'}`}
        title={unlocked ? 'Vault unlocked — data is encrypted' : 'Vault locked — click to unlock'}
      >
        <IconVault size={14} active />
        <span>Vault</span>
        <span
          className="w-1.5 h-1.5 rounded-full"
          style={{ backgroundColor: unlocked ? '#4CAF50' : '#F44336' }}
        />
      </button>

      <VaultUnlockDialog
        open={showUnlock}
        onClose={() => setShowUnlock(false)}
        onUnlocked={() => setShowUnlock(false)}
      />
    </>
  );
}
